<span class="obg-m-social-login-container-separator">{{ 'login.social-login.separator' | translate }}</span>
<obg-google-login></obg-google-login>
